import { Injectable, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Observable } from "rxjs";

import { ViewDistributorsDialogComponent } from "./view-distributors-dialog.component";

@Injectable({
  providedIn: "root"
})
export class ViewDistributorsDialogService {
  private dialog = inject(MatDialog);

  public dataSource = [];

  public viewDistributors(component, id): Observable<boolean> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;
    config.data = {
      component: component,
      id: id
    };

    const dialogRef = this.dialog.open(ViewDistributorsDialogComponent, config);
    return dialogRef.afterClosed();
  }
}
